// extracted by mini-css-extract-plugin
export default {"wrapper":"ActionButtons_wrapper__E76sx"};